<template>
  <div class="shipping-option">
    <div class="name">{{ rate.name }}</div>
    <div class="price">
      {{ ratePrice }}
    </div>
    <div v-if="info" class="info">{{ info }}</div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "ShippingOption",
  props: {
    rate: {
      type: Object,
      required: true,
    },
    weight: {
      type: Number,
      default: 0.2,
    },
  },
  computed: {
    ...mapState("app", ["userCountry"]),
    ...mapGetters("app", ["userPostCode", "currencyCode"]),
    postcode() {
      if (this.userPostCode) {
        return this.userPostCode;
      }

      return this.usersEstimatedPostCode;
    },
    ratePrice() {
      const isFree = this.rate.price === "0.00";

      if (isFree) {
        return "FREE";
      }

      return this.$filters.toCurrency(this.rate.price, this.currencyCode, 0);
    },
    info() {
      const maxCondition = this.rate.max_order_subtotal
        ? this.$filters.toCurrency(
            this.rate.max_order_subtotal,
            this.currencyCode,
            0
          )
        : null;
      const minCondition = this.rate.min_order_subtotal
        ? this.$filters.toCurrency(
            this.rate.min_order_subtotal,
            this.currencyCode,
            0
          )
        : null;

      const conditions = {
        all: `on all orders`,
        min: `on orders over ${minCondition}`,
        max: `on orders up to ${maxCondition}`,
        both: `on orders between ${minCondition} and ${maxCondition}`,
      };

      if (!minCondition && !maxCondition) {
        return conditions["all"];
      } else if (minCondition && maxCondition) {
        return conditions["both"];
      } else if (minCondition) {
        return conditions["min"];
      } else if (maxCondition) {
        return conditions["max"];
      } else {
        return conditions["max"];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shipping-option {
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "name price" "info info";

  .name {
    @include utility-button(14px);
    grid-area: name;
  }

  .info {
    @include utility-body(14px);
    grid-area: info;
  }

  .price {
    @include utility-button(14px);
    grid-area: price;
    text-align: right;
  }
}
</style>
